export const FAQ = [
	{
		pergunta: "O que é a MMS?",
		resposta:
			"A MMS — Muito Mais Serviços — é uma rede que conecta montadores de móveis a clientes em todo o Brasil, oferecendo agenda flexível, atendimento contínuo e suporte exclusivo para profissionais parceiros.",
	},
	{
		pergunta: "Quem pode se cadastrar como montador parceiro?",
		resposta:
			"Profissionais com CNPJ ativo, capacidade de emitir nota fiscal e experiência comprovada em montagem de móveis. É necessário ter ferramentas próprias e meio de transporte para se deslocar até os clientes.",
	},
	{
		pergunta: "Como funciona o pagamento dos serviços?",
		resposta:
			"Os pagamentos são realizados a cada 15 dias, mediante emissão de nota fiscal pelo parceiro, diretamente em conta corrente cadastrada na plataforma.",
	},
	{
		pergunta: "Posso escolher os horários e regiões em que quero atender?",
		resposta:
			"Sim. Cada parceiro define os dias, períodos e cidades de atuação no momento do cadastro, podendo atualizá-los sempre que necessário.",
	},
	{
		pergunta: "Quais ferramentas preciso ter para começar?",
		resposta:
			"Kit básico de ferramentas elétricas e manuais para montagem de móveis (parafusadeira, furadeira, chaves, esquadro, fita métrica, nível) e EPI quando aplicável.",
	},
	{
		pergunta: "A MMS oferece treinamento?",
		resposta:
			"Sim. Oferecemos uma trilha de treinamentos sobre o sistema TOA, melhores práticas de atendimento e materiais informativos disponíveis dentro da plataforma.",
	},
	{
		pergunta: "Em quanto tempo recebo a primeira ordem de serviço após o cadastro?",
		resposta:
			"Após a aprovação do cadastro e conclusão do treinamento obrigatório, as primeiras ordens são distribuídas conforme a demanda da sua região.",
	},
	{
		pergunta: "Como entro em contato com a Central de Atendimento?",
		resposta:
			"Use o canal exclusivo dentro da plataforma ou os contatos disponibilizados na seção 'Fale Conosco'. Nosso time responde em horário comercial.",
	},
];
